import Api from '@/services/Api'
import GmwApi from '@/services/GmwApi'

export default {
    getallnames () {
        return Api().get('products/getallnames')
    },
    getall () {
        return Api().get('products/getall')
    },
    getsmrates () {
        return Api().get('products/getsmrates')
    },
    // getallstock () {
    //     return Api().get('products/allproductstock')
    // },
    getallstocksm () {
        return Api().get('bills/getsmstock')
    },
    getstockbooksm (product, startdate, enddate) {
        return Api().get('products/getstockbook/'+product+'/'+startdate+'/'+enddate)
    },

    //GMW
    getallnamesgmw () {
        return GmwApi().get('products/getallnames')
    },
    getallgmw () {
        return GmwApi().get('products/getall')
    },
    getallstockgmw () {
        return GmwApi().get('products/allproductstock')
    },
    getstockbookgmw (product, startdate, enddate) {
        return GmwApi().get('products/getstockbook/'+product+'/'+startdate+'/'+enddate)
    },
}